import { render, staticRenderFns } from "./BankEFT.vue?vue&type=template&id=787536e8&"
import script from "./BankEFT.vue?vue&type=script&lang=js&"
export * from "./BankEFT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports